import Medusa, { type ClientHeaders } from "@medusajs/js-sdk";

export const backendUrl = __BACKEND_URL__ ?? "/";

function resolveSpecialHeaders(): ClientHeaders | undefined {
  if (__X_DEV_KEY__) {
    return {
      "X-Dev-Key": __X_DEV_KEY__,
    }
  }

  return undefined
}

export const sdk = new Medusa({
  baseUrl: backendUrl,
  globalHeaders: resolveSpecialHeaders()
});

// useful when you want to call the BE from the console and try things out quickly
if (typeof window !== "undefined") {
  (window as any).__sdk = sdk;
}
